/**
 * 通用 JSON MQTT WebSocket（/api/mqtt-json/ws）
 * 连接后发送 {"action":"subscribe","topic":"*"} 收全部上行
 */

function getWsBaseUrl() {
  const env = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE;
  const base = (env && String(env).trim()) || 'https://paizhao.yunjiaozu.com';
  return base.replace(/^http/i, (m) => (m.toLowerCase() === 'https' ? 'wss' : 'ws'));
}

/**
 * @param {(topic: string, message: string, at?: string) => void} onMessage
 * @param {{ onClose?: () => void }} [options]
 */
export function createMqttJsonWS(onMessage, options = {}) {
  const onCloseCb = typeof options.onClose === 'function' ? options.onClose : null;
  const url = `${getWsBaseUrl()}/api/mqtt-json/ws`;
  let socket = null;
  let closed = false;
  let resolveReady;
  let rejectReady;
  const ready = new Promise((resolve, reject) => {
    resolveReady = resolve;
    rejectReady = reject;
  });

  try {
    socket = new WebSocket(url);
  } catch (e) {
    rejectReady(e);
    return { close: () => {}, ready: Promise.reject(e), isOpen: () => false };
  }

  socket.onopen = () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({ action: 'subscribe', topic: '*' }));
    }
    resolveReady();
  };
  socket.onerror = () => {
    if (onCloseCb) onCloseCb();
    rejectReady(new Error('WebSocket 连接失败'));
  };
  socket.onclose = () => {
    if (onCloseCb) onCloseCb();
  };
  socket.onmessage = (ev) => {
    try {
      const data = JSON.parse(ev.data);
      const t = data.topic || '';
      const msg = data.message != null ? String(data.message) : '';
      const at = data.at != null ? String(data.at) : '';
      if (typeof onMessage === 'function') onMessage(t, msg, at);
    } catch (_) {}
  };

  const close = () => {
    if (closed) return;
    closed = true;
    try {
      if (socket && socket.readyState === WebSocket.OPEN) socket.close();
    } catch (_) {}
    socket = null;
  };

  return {
    close,
    ready,
    isOpen: () => !!(socket && socket.readyState === WebSocket.OPEN),
  };
}
